import React from "react";
import SummaryCommissionSection from "./SummaryCommissionSection";
import { CircularProgress, Grid, Typography } from "@material-ui/core";
import { FormattedMessage } from "react-intl";
import useGetAgentSummary from "../../../hooks/useGetAgentSummary";
import { Roles } from "../../../util";
import ContractsStatusOverview from "./ContractsStatusOverview";

const SummaryAgentContent = () => {
  const { summary, loading, error } = useGetAgentSummary();

  if (loading)
    return (
      <Grid
        container
        justify="center"
        style={{
          marginTop: "10%",
        }}
      >
        <CircularProgress />
      </Grid>
    );

  if (error)
    return (
      <Grid container justify="center">
        <Typography variant="body1" align="center" color="error">
          <FormattedMessage id="app.error.generic" />
        </Typography>
      </Grid>
    );
  return (
    <>
      <SummaryCommissionSection
        commissionCurrentMonth={summary.commissionCurrentMonth}
        recommendantCurrentMonth={summary.recommendantCurrentMonth}
        splitCurrentMonth={summary.splitCurrentMonth}
        totalReceivedCurrentMonth={summary.totalReceivedCurrentMonth}
        totalReceivedPreviousMonth={summary.totalReceivedPreviousMonth}
        viewContext={Roles.Agent}
      />
      <ContractsStatusOverview />
    </>
  );
};

export default SummaryAgentContent;
